var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid crm-page-wrapper error-404"},[_c('center',[_c('v-img',{attrs:{"contain":"","width":"400","height":"100%","src":_vm.items[0].url}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }